import { render, staticRenderFns } from "./collapseTitle.vue?vue&type=template&id=5efe4eda&scoped=true"
import script from "./collapseTitle.vue?vue&type=script&lang=js"
export * from "./collapseTitle.vue?vue&type=script&lang=js"
import style0 from "./collapseTitle.vue?vue&type=style&index=0&id=5efe4eda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efe4eda",
  null
  
)

export default component.exports